// extracted by mini-css-extract-plugin
export default {"form-container":"styles_form-container__VTg9L"};